export enum PersonRole {
    Supervisor = 'supervisor',
    Director = 'director',
    Support = 'support',
}

export enum Stage {
    Client = 'CLIENT',
    Potential = 'POTENTIAL',
}

export enum Industry {
    Finance = 'FINANCE',
    FoodAndBeverage = 'FOOD_AND_BEVERAGE',
    Insurance = 'INSURANCE',
    Software = 'SOFTWARE_DEVELOPMENT',
}

export enum Priority {
    VIP = 'VIP',
    High = 'HIGH',
    Normal = 'NORMAL',
    Low = 'LOW',
}

export enum DataRange {
    Registration = 'REGISTRATION',
    Expiration = 'EXPIRATION',
    FirstReservation = 'FIRST_RESERVATION_DATE',
    LastReservation = 'LAST_RESERVATION_DATE',
    AccrualOfBonusPoints = 'ACCRUAL_OF_BONUS_POINTS',
    ContractExpiration = 'CONTRACT_EXPIRATION',
    dateOfBirth = 'DATE_OF_BIRTH',
}

export enum Company {
    TourAgency = 'TOUR_AGENCY',
    TourOperator = 'TOUR_OPERATOR',
    Corporator = 'CORPORATOR',
    HubSupplier = 'HUB_SUPPLIER',
    InternalSupplier = 'INTERNAL_SUPPLIER',
}

export enum Months {
    January = 1,
    February = 2,
    March = 3,
    April = 4,
    May = 5,
    June = 6,
    July = 7,
    August = 8,
    September = 9,
    October = 10,
    November = 11,
    December = 12,
}

export type SelectOptionType = {value: string | number; title: string}

export type TableHeadersType = {
    title: string
    value: string
    key?: string
    align?: string
    width?: string
    fixed?: boolean
    show?: boolean
}[]

export enum OrderDocument {
    ActServices = 'ACT_SERVICES',
    RequestFromClient = 'REQUEST_FROM_CLIENT',
    RequestToSupplier = 'REQUEST_TO_SUPPLIER',
    RouteInvoice = 'ROUTE_INVOICE',
    ClientConfirmation = 'CLIENT_CONFIRMATION',
    ConfirmationFromSupplier = 'CONFIRMATION_FROM_SUPPLIER',
    ClientInvoice = 'CLIENT_INVOICE',
    InvoiceFromSupplier = 'INVOICE_FROM_SUPPLIER',
    Sof = 'SOF',
    ClientLetterTl = 'CLIENT_LETTER_TL',
    OrderForBusinessTrip = 'ORDER_FOR_BUSINESS_TRIP',
    BusinessTripPermit = 'BUSINESS_TRIP_PERMIT',
    ExpenseReport = 'EXPENSE_REPORT',
    WorkTask = 'WORK_TASK',
    Other = 'OTHER',
}

export enum UserDocument {
    Passport = 'PASSPORT',
    BirthCertificate = 'BIRTH_CERTIFICATE',
    Questionary = 'QUESTIONARY',
    LetterOfAttorney = 'LETTER_OF_ATTORNEY',
    Sof = 'SOF',
    Visa = 'VISA',
    Photo = 'PHOTO',
    MedicalCertificate = 'MEDICAL_CERTIFICATE',
}

export enum CompanyDocument {
    Contract = 'CONTRACT',
    Offer = 'OFFER',
    Report = 'REPORT',
    TripPolicy = 'TRIP_POLICY',
    PriceList = 'PRICE_LIST',
    Questionary = 'QUESTIONARY',
    GuaranteeLetter = 'GUARANTEE_LETTER',
    LetterOfAttorney = 'LETTER_OF_ATTORNEY',
    Request = 'REQUEST',
    InfoLetter = 'INFO_LETTER',
    Logo = 'LOGO',
    Photo = 'PHOTO',
    Other = 'OTHER',
}

export enum Location {
    Airport = 'AIRPORT',
    City = 'CITY',
    Accommodation = 'ACCOMMODATION',
}

export enum Activity {
    Excursion = 'EXCURSION',
    Event = 'EVENT',
}

export enum contractServiceType {
    ownHotel = 'ownHotel',
    ownCharter = 'ownCharter',
    ownExcursion = 'ownExcursion',
    concert = 'concert',
    ownTransfer = 'ownTransfer',
    ownCarRent = 'ownCarRent',
    ownCruise = 'ownCruise',
    tour = 'tour',
    ownExtraService = 'ownExtraService',
    ownInsurance = 'ownInsurance',
    ownVisa = 'ownVisa',
    customComplexTour = 'customComplexTour',
}

export enum guestCategory {
    Adults = 'ADULTS',
    Children = 'CHILDREN',
}

export enum ServiceClass {
    Econom = 'ECONOM',
    Business = 'BUSINESS',
    PremiumEconomy = 'PREMIUM_ECONOMY',
    First = 'FIRST',
}

export enum CharterExtraServiceCategory {
    Baggage = 'BAGGAGE',
    Meal = 'MEAL',
    PriorityBoarding = 'PRIORITY_BOARDING',
    TaxesAndFees = 'TAXES_AND_FEES',
    Other = 'OTHER',
}

export enum UnitOfMeasure {
    Pieces = 'PIECES',
    Kilograms = 'KILOGRAMS',
    Pounds = 'POUNDS',
}

export enum Sharing {
    Shared = 'SHARED',
    Private = 'PRIVATE',
}

export enum ExcursionService {
    Audio = 'AUDIO',
    Guide = 'GUIDE',
    Other = 'OTHER',
}

export enum Transportation {
    Walking = 'WALKING',
    OffSite = 'OFF_SITE',
}

export enum TimeInterval {
    AnyTime = 'ANY_TIME',
    FixedTime = 'FIXED_TIME',
    Interval = 'TIME_INTERVAL',
}

export enum StartEndLocation {
    'Airport' = 'AIRPORT',
    'Station' = 'STATION',
    'Hotel' = 'HOTEL',
    'Address' = 'ADDRESS',
    'Port' = 'PORT',
    'Manual' = 'MANUAL',
}

export enum CarFeatures {
    AirConditioning = 'AIR_CONDITIONING',
    AutomaticTransmission = 'AUTOMATIC_TRANSMISSION',
    ManualTransmission = 'MANUAL_TRANSMISSION',
    BackUpCamera = 'BACK_UP_CAMERA',
    BlindSpotMonitoring = 'BLIND_SPOT_MONITORING',
    Bluetooth = 'BLUETOOTH',
    KeylessEntry = 'KEYLESS_ENTRY',
    RoadsideAssistance = 'ROADSIDE_ASSISTANCE',
    ThirdPartyInsurance = 'THIRD_PARTY_INSURANCE',
    UnlimitedMileage = 'UNLIMITED_MILEAGE',
}

export enum Fuel {
    Diesel = 'DIESEL',
    Hybrid = 'HYBRID',
    Electric = 'ELECTRIC',
    Gas = 'LPG_COMPRESSED_GAS',
    Hydrogen = 'HYDROGEN',
    MultiFuel = 'MULTI_FUEL',
    Petrol = 'PETROL',
    Ethanol = 'ETHANOL',
}

export enum VehicleClass {
    Compact = 'COMPACT',
    Economy = 'ECONOMY',
    Electric = 'ELECTRIC',
    FullSize = 'FULL_SIZE',
    Luxury = 'LUXURY',
    MidSize = 'MID_SIZE',
    Premium = 'PREMIUM',
    Standard = 'STANDARD',
}

export enum Transmission {
    Automatic = 'AUTOMATIC',
    Manual = 'MANUAL',
}

export enum VehicleCategory {
    Car = 'CAR',
    Minivan = 'MINIVAN',
    Pickup = 'PICKUP',
    Suv = 'SUV',
    Truck = 'TRUCK',
    Van = 'VAN',
}

export enum Itinerary {
    Accommodation = 'ACCOMMODATION',
    Transfer = 'TRANSFER',
    Flight = 'FLIGHT',
    Excursion = 'EXCURSION',
    Insurance = 'INSURANCE',
    Event = 'EVENT',
    Extra = 'EXTRA_SERVICE',
    Car = 'CAR',
    Cruise = 'CRUISE',
}

export enum Ship {
    Gulet = 'GULET',
    Catamaran = 'CATAMARAN',
    CruiseShip = 'CRUISE_SHIP',
    MotorYacht = 'MOTOR_YACHT',
    SailingYacht = 'SAILING_YACHT',
}

export enum Event {
    Sport = 'SPORT',
    Concert = 'CONCERT',
    Other = 'OTHER',
}

export enum RoomCode {
    OTHER = '',
    SINGLE = '1',
    DOUBLE = '2',
    TRIPLE = '6',
    QUADRUPLE = '7',
    FAMILY = '8',
}
